import { cx } from '@linaria/atomic';
import type { CommonHTMLAttributes } from '@frontend/types';
import { mergeClasses } from '../../../helpers';
import { Button } from '../../button';
import { Heading } from '../../heading';
import { Text } from '../../text';
import { useModalContext } from '../provider';
import { modalHeader, modalHeaderCloseButton, modalHeaderHeading, modalLabel } from './modal-header.styles';

type Props = CommonHTMLAttributes & {
  onClose?: () => void;
  closeBtnTrackingId?: string;
  children?: React.ReactNode;
  textAlign?: 'left' | 'center';
};

export const ModalHeader = ({
  children,
  className,
  textAlign = 'left',
  closeBtnTrackingId = 'modal-close-icon-button',
  onClose,
  ...rest
}: Props) => {
  const { titleId } = useModalContext();

  return (
    <header className={cx(modalHeader, mergeClasses('wv-modal-header', className))}>
      <Heading className={modalHeaderHeading} level={2} textAlign={textAlign} {...rest} id={titleId}>
        {children}
      </Heading>
      {onClose && (
        <Button
          trackingId={closeBtnTrackingId}
          aria-label='close'
          onClick={onClose}
          className={modalHeaderCloseButton}
          iconName='x-small'
          variant='secondary'
        />
      )}
    </header>
  );
};

export const ModalLabel = ({
  children,
  className,
  ...rest
}: CommonHTMLAttributes & {
  children: React.ReactNode;
}) => {
  return (
    <div className={cx(modalLabel, mergeClasses('wv-modal-label', className))} {...rest}>
      {typeof children === 'string' ? (
        <Text as='span' color='light' size='small'>
          {children}
        </Text>
      ) : (
        children
      )}
    </div>
  );
};
